// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddTipsForm-addTipsImageContainer-coZtc {
    position: relative;
    width: 88px;
    height: 88px;
    border-radius: var(--radius-3);
    margin: 0 auto;
    margin-bottom: 18px;
    background-color: var(--primary-gray-bg);
}

.AddTipsForm-addTipsImageContainer-coZtc img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    border-radius: inherit;
}`, "",{"version":3,"sources":["webpack://./src/components/AddTipsForm/AddTipsForm.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,sBAAsB;AAC1B","sourcesContent":[".addTipsImageContainer {\n    position: relative;\n    width: 88px;\n    height: 88px;\n    border-radius: var(--radius-3);\n    margin: 0 auto;\n    margin-bottom: 18px;\n    background-color: var(--primary-gray-bg);\n}\n\n.addTipsImageContainer img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: inherit;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addTipsImageContainer": `AddTipsForm-addTipsImageContainer-coZtc`
};
module.exports = ___CSS_LOADER_EXPORT___;
